module.exports = __webpack_public_path__ + "static/img/act-steps-m-1-hk.0e1ba1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-1-hk.png
// module id = 6uHu
// module chunks = 1